/**
 * The leaf's one wire error (wire-error-standard.md).
 *
 * The codes are APPEND-ONLY once shipped. A read of a set of table names has
 * one way to fail that a caller can act on, which is to try again, so there is
 * one code; the trace id ties it to the server log line carrying the cause.
 */
import { defineWireError } from "@/shared/error-diagnostics/wire"

export const AUDIT_CHANGES_ERROR_CODES = ["AUDIT_CHANGES_INTERNAL"] as const

export class AuditChangesWireError extends defineWireError<AuditChangesWireError>()(
  "AuditChangesWireError",
  AUDIT_CHANGES_ERROR_CODES,
) {}
